import { createEnumeratorAttrMap, IEnumeratorModel } from "./IEnumeratorModel";

export type ICPVModel = IEnumeratorModel;
export const CPVModelAttrMap = createEnumeratorAttrMap('CPV');
